module.exports = __webpack_public_path__ + "images/snake-eye-ab0d4190692e3b9d4ed2a107301fe61e.png";